import React from "react";
import Modal from "react-bootstrap/cjs/Modal";

const ValidationModel: React.FC<{
  show: boolean;
  handleClose: any;
  type: string;
  message: string;
  onYesClick: any;
}> = ({ show, handleClose, type, message, onYesClick }) => {
  return (
    <Modal className="alert-modal" show={show}
    //  onHide={handleClose}
      size="lg">
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body className="Loading">
        <div>
          {/* <div className="Loading "> */}
          <img src="/icons/error.svg" className="loading_image" />
          {/* <p className=" popup_typography loading_typography_error">{message}</p>
           */}
           <div style={{ textAlign: "center" }}>
              <p className="loading_typography">{message}</p>
            </div>
          {/* <div className="error_bar"></div> */}
          {/* </div> */}
          {/* <p className="message_typography">{message}</p> */}
       
        <button
          data-auto="inviteButton"
          className="spectrum-Button spectrum-Button--cta inviteButton-I4RMS"
          onClick={function () {
            handleClose();
            onYesClick();
          }}
        >
          <span>YES</span>
        </button>
        <button
          onClick={handleClose}
          data-auto="inviteButton"
          className="spectrum-Button spectrum-Button--cta inviteButton-I4RMS"
        >
          <span>NO</span>
        </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ValidationModel;
